/* eslint-disable */
import { useState, useEffect } from "react";
import CommunityHeader from "../Header/CommunityHeader";
import CommunityLeftPanel from "../Panels/CommunityLeftPanel";
import CommunityRightPanel from "../Panels/CommunityRightPanel";
import CreatePostModal from "../Modals/CreatePostModal";
import PostSuccessModal from "../Modals/PostSuccessModal";
import CommentModal from "../Modals/CommentModal";

/*import url and gateway methods */
import { getData, postData, putData, uploadMultipleFile } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import AddTagModal from "Components/Common/Modals/AddTagModal";
import { updateForumData } from "helper/ForumHelper/ForumHelper";
import CommunityFilterPopup from "../Popups/CommunityFilterPopup";

const CommunitySection = ({ eventId }) => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const limitResult = 10;

  const [isLoading, setisLoading] = useState(false);
  const [forumList, setForumList] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [memberList, setMemberList] = useState([]);

  const [forumId, setforumId] = useState(null);

  const [filterEcosystem, setFilterEcosystem] = useState(null);
  const [filterDateRange, setFilterDateRange] = useState("");
  const [filterIsPrivate, setfilterIsPrivate] = useState(false);
  const [filterMod, setfilterMod] = useState(null);
  const [filterQuery, setfilterQuery] = useState("");
  const [filterEvents, setfilterEvents] = useState([]);
  const [filterGroups, setfilterGroups] = useState([]);
  const [filterTags, setfilterTags] = useState([]);
  const [filterWinnerPost, setfilterWinnerPost] = useState(false);
  const [filterNotWinnerPost, setfilterNotWinnerPost] = useState(false);
  const [filterPostMods, setfilterPostMods] = useState([]);

  const [detailsLoading, setdetailsLoading] = useState(false);
  const [title, settitle] = useState("");
  const [description, setdescription] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [isPrivate, setIsPrivate] = useState(false);

  const [editedForumId, setEditedForumId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [moderatorId, setmoderatorId] = useState(null);
  const [moderatorName, setmoderatorName] = useState("");
  const [moderatorImage, setmoderatorImage] = useState("");
  const [forumTimeAgo, setforumTimeAgo] = useState("");
  const [tags, settags] = useState([]);
  const [likeCount, setLikeCount] = useState(0);
  const [commentCount, setCommentCount] = useState(0);
  const [commentList, setCommentList] = useState([]);

  const [tagFourmId, setTagFourmId] = useState(null);

  const [topCommentId, settopCommentId] = useState(null);
  const [winnerId, setwinnerId] = useState(null);

  const [selectedCommentId, setselectedCommentId] = useState(null);

  const [similarList, setsimilarList] = useState([]);

  const [totalRecords, setTotalRecords] = useState(0);

  const [pageNo, setPageNo] = useState(0);

  //function for get all tags
  const getAllTags = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_TAGS + `?token=${token}`;

      const response = await getData(requestUrl);

      // console.log(response);

      if (response.status) {
        setTagList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get event details
  const getEventMembers = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GUEST_ALL_EVENT_MEMBER +
        `?event=${eventId}&isselect=${true}`;

      // console.log("url of event members ------>", requestUrl);

      const response = await getData(requestUrl);

      // console.log("response of event members ------>", response);

      if (response.status) {
        setMemberList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //get all post
  const getAllForums = async (start, limit, isAfterEdit) => {
    try {
      setisLoading(true);

      let requestURL =
        url.API_BASE_URL +
        url.API_GUEST_ALL_FORUM +
        `?loggedinuserid=${userInfo?._id}&start=${start}&limit=${limit}&filterevents=${eventId}`;

      if (filterDateRange != "") {
        requestURL = requestURL + `&filterdates=${filterDateRange}`;
      }

      // if (filterIsPrivate) {
      //   requestURL = requestURL + `&filterisprivate=${filterIsPrivate}`;
      // }

      // if (filterMod) {
      //   requestURL = requestURL + `&filtermod=${filterMod}`;
      // }

      if (filterQuery != "") {
        requestURL = requestURL + `&filterquery=${filterQuery}`;
      }

      // if (filterEvents.length > 0) {
      //   requestURL = requestURL + `&filterevents=${filterEvents}`;
      // }

      // if (filterGroups.length > 0) {
      //   requestURL = requestURL + `&filtergroups=${filterGroups}`;
      // }

      if (filterTags.length > 0) {
        requestURL = requestURL + `&filterlabels=${filterTags}`;
      }

      if (filterWinnerPost) {
        requestURL = requestURL + `&filterwinnerpost=${filterWinnerPost}`;
      }

      if (filterNotWinnerPost) {
        requestURL = requestURL + `&filternotwinnerpost=${filterNotWinnerPost}`;
      }

      if (filterPostMods.length > 0) {
        requestURL = requestURL + `&filterpostmods=${filterPostMods}`;
      }

      // if (filterEcosystem) {
      //   requestURL = requestURL + `&filterecosystemid=${filterEcosystem}`;
      // }

      if (isAfterEdit) {
        requestURL =
          url.API_BASE_URL +
          url.API_GUEST_ALL_FORUM +
          `?loggedinuserid=${userInfo?._id}&updatedforumid=${forumId}`;
      }

      // console.log(requestURL);

      const response = await getData(requestURL);

      setisLoading(false);

      // console.log(response);

      if (response.status) {
        if (response.totalrecords) {
          setTotalRecords(response.totalrecords);
        }

        if (response.data.length > 0) {
          setForumList(response.data);
          if (start == 0) {
            if (isAfterEdit) {
              const respondedData = response.data;

              const updatedArray = updateForumData(forumList, respondedData);

              setForumList(updatedArray);
            } else {
              setforumId(response.data[0]._id);
            }
          } else {
            if (isAfterEdit) {
              const respondedData = response.data;

              const updatedArray = updateForumData(forumList, respondedData);

              setForumList(updatedArray);
            } else {
              // setForumList(response.data);
              setForumList([...forumList, ...response.data]);
            }
          }
        } else {
          setForumList([]);
          setforumId(null);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //get post details
  const getPostDetails = async () => {
    setdetailsLoading(true);
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GUEST_FORUM_DETAILS +
        `/${forumId}?loggedinuserid=${userInfo?._id}`;

      console.log(requestURL);

      const response = await getData(requestURL);

      console.log(response);
      setdetailsLoading(false);
      if (response.status) {
        settitle(response.data.title);
        setdescription(response.data.description);
        settags(response.data.taglistarr);

        setUploadedFiles(response.data?.uploads);

        setIsPrivate(response.data.isprivate);

        setmoderatorId(response.data.moderator?._id);
        setmoderatorImage(response.data.moderatorimage);
        setmoderatorName(response.data.moderatorname);
        setforumTimeAgo(response.data.timestring);
        setLikeCount(response.data.likes ? response.data.likes.length : 0);
        setCommentCount(response.data.commentlist.length);
        setCommentList(response.data.commentlist);
        settopCommentId(response.data?.topcomment);
        setwinnerId(response.data?.winner);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //like/dislike forum
  const toggleLikeForum = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_TOGGLE_LIKE_FORUM_POST +
        `/${forumId}?token=${token}`;

      const response = await putData(requestURL);

      console.log(response);

      if (response.status) {
        getAllForums(pageNo, limitResult, true);
        getPostDetails();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //deletePostHandler
  const deletePostHandler = async () => {
    let forumData = {
      status: "0",
    };
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_UPDATE_FORUM +
        `/${forumId}` +
        `?token=${token}`;

      const response = await putData(requestURL, forumData);
      if (response.status) {
        setPageNo(0);
        getAllForums(0, limitResult, false);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //edit comment
  const editCommentHandler = (id) => {
    setselectedCommentId(id);
  };

  //delete comment
  const deleteCommentHandler = async (id) => {
    try {
      let forumData = {
        status: "0",
      };

      let requestURL =
        url.API_BASE_URL + url.API_UPDATE_COMMENT + `/${id}?token=${token}`;

      const response = await putData(requestURL, forumData);

      // console.log(response);

      if (response.status) {
        getPostDetails();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //like a comment
  const toggleLikeComment = async (commnetId) => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_TOGGLE_LIKE_FORUM_COMMENT +
        `/${commnetId}?token=${token}`;

      const response = await putData(requestURL);

      console.log(response);

      if (response.status) {
        // getAllForums(pageNo, limitResult, true);
        getPostDetails();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //make winner
  const winnerHandler = async (commentId, commnetOwnerId) => {
    try {
      let forumData = {
        topcomment: commentId,
        winner: commnetOwnerId,
      };

      let requestURL =
        url.API_BASE_URL + url.API_UPDATE_FORUM + `/${forumId}?token=${token}`;

      const response = await putData(requestURL, forumData);

      // console.log(response);

      if (response.status) {
        // let myModal = new bootstrap.Modal(
        //   document.getElementById("success_comment_mdl")
        // );
        // myModal.show();
        getAllForums(pageNo, limitResult, true);
        getPostDetails();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //click load more button
  const onNextPage = () => {
    setPageNo(pageNo + 1);
  };

  //after post modal close
  const onModalPostClose = () => {
    if (isEdit) {
      getAllForums(pageNo, limitResult, true);
      getPostDetails();
      setIsEdit(false);
    } else {
      setPageNo(0);
      getAllForums(0, limitResult, false);
    }
  };

  const onTagModalClose = () => {
    getPostDetails();
    setTagFourmId(null);
  };

  const resetForum = () => {
    setforumId(null);
    // getAllForums();
  };

  const resetFilter = () => {
    // setFilterEcosystem(null);
    setFilterDateRange("");
    // setfilterIsPrivate(false);
    // setfilterMod(null);
    setfilterQuery("");
    // setfilterEvents([]);
    // setfilterGroups([]);
    setfilterTags([]);
    setfilterPostMods([]);
    setfilterWinnerPost(false);
    setfilterNotWinnerPost(false);
  };

  //refresh
  const refreshHandler = () => {
    resetFilter();
    setforumId(null);
    setForumList([]);
    setPageNo(0);
    getAllForums(0, limitResult, false);
  };

  //use effect for filter search
  // useEffect(() => {
  //   if (
  //     // filterDateRange != "" ||
  //     // filterIsPrivate ||
  //     // filterMod ||
  //     filterQuery != ""
  //     // filterEvents.length > 0 ||
  //     // filterGroups.length > 0 ||
  //     // filterTags.length > 0 ||
  //     // filterEcosystem
  //   ) {
  //     setPageNo(0);
  //     getAllForums(0);
  //   }
  // }, [
  //   // filterDateRange,
  //   // filterIsPrivate,
  //   // filterMod,
  //   filterQuery,
  //   // filterEvents,
  //   // filterGroups,
  //   // filterTags,
  //   // filterEcosystem,
  // ]);

  useEffect(() => {
    if (forumId) {
      getPostDetails();
    }
  }, [forumId]);

  useEffect(() => {
    if (
      pageNo ||
      filterQuery != "" ||
      filterDateRange != "" ||
      filterTags.length > 0 ||
      filterWinnerPost ||
      filterNotWinnerPost ||
      filterPostMods.length > 0
    ) {
      getAllForums(pageNo, limitResult, false);
    } else {
      getAllForums(0, limitResult, false);
    }
  }, [
    pageNo,
    filterQuery,
    filterDateRange,
    filterTags,
    filterWinnerPost,
    filterNotWinnerPost,
    filterPostMods,
  ]);

  useEffect(() => {
    if (token) {
      getAllTags();
    }
    getEventMembers();
  }, []);

  return (
    <div className="forum_sec">
      <CommunityHeader
        setfilterQuery={setfilterQuery}
        refreshHandler={refreshHandler}
      />
      <div className="activity_outer mt-5">
        <div className="row">
          <CommunityLeftPanel
            setforumId={setforumId}
            forumList={forumList}
            isLoading={isLoading}
            onNextPage={onNextPage}
            totalRecords={totalRecords}
            // setTagFourmId={setTagFourmId}
            filterQuery={filterQuery}
          />
          <CommunityRightPanel
            forumId={forumId}
            setforumId={setforumId}
            title={title}
            description={description}
            forumTimeAgo={forumTimeAgo}
            moderatorId={moderatorId}
            moderatorImage={moderatorImage}
            moderatorName={moderatorName}
            uploadedFiles={uploadedFiles}
            detailsLoading={detailsLoading}
            likeCount={likeCount}
            commentCount={commentCount}
            commentList={commentList}
            toggleLikeForum={toggleLikeForum}
            onEditComment={editCommentHandler}
            onDeleteComment={deleteCommentHandler}
            winnerHandler={winnerHandler}
            topCommentId={topCommentId}
            winnerId={winnerId}
            toggleLikeComment={toggleLikeComment}
            isPrivate={isPrivate}
            setEditedForumId={setEditedForumId}
            tags={tags}
            deletePostHandler={deletePostHandler}
            setTagFourmId={setTagFourmId}
          />
        </div>
      </div>

      {/* modal and popup */}
      {token && (
        <CreatePostModal
          eventId={eventId}
          editedForumId={editedForumId}
          setEditedForumId={setEditedForumId}
          setIsEdit={setIsEdit}
        />
      )}

      <PostSuccessModal onModalClose={onModalPostClose} />

      {token && (
        <CommentModal
          forumId={forumId}
          selectedCommentId={selectedCommentId}
          onModalClose={() => {
            getAllForums(pageNo, limitResult, true);
            getPostDetails();
            setselectedCommentId(null);
          }}
        />
      )}

      {token && (
        <AddTagModal
          moduleName={"activity"}
          selectedId={tagFourmId}
          onModalClose={onTagModalClose}
        />
      )}

      <CommunityFilterPopup
        token={token}
        tagList={tagList}
        memberList={memberList}
        setfilterTags={setfilterTags}
        setFilterDateRange={setFilterDateRange}
        setfilterWinnerPost={setfilterWinnerPost}
        setfilterNotWinnerPost={setfilterNotWinnerPost}
        setfilterPostMods={setfilterPostMods}
      />
    </div>
  );
};

export default CommunitySection;
